import React, { useMemo, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import useDetailFetch from '../../../../hooks/useDetailFetch';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';

const SingleOpportunityActivityDetails = () => {
  const { activityId: id } = useParams();
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);

  const decodedId = id ? atob(id) : id;
  const activityId = decodedId.replace(/\D/g, '');

  const [showDelete, setShowDelete] = useState(false);

  const url = activityId ? `${API_DOMAIN}${API_ROUTES.opportunityActivity}${activityId}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1).replace(/_/g, ' '), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_DOMAIN}${API_ROUTES.opportunityActivity}${activityId}/`, { headers });
      showToast('Opportunity activity deleted successfully', 'success');
      navigate('/opportunity/activity/list');
    } catch (error) {
      console.error('Error deleting opportunity activity:', error);
      showToast('Error deleting opportunity activity', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Opportunity Activity"
        listPath="/opportunity/activity/list"
        editPath={`/opportunity/activity/input/${btoa(activityId)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Opportunity Activity"
        message="Are you sure you want to delete this opportunity activity?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SingleOpportunityActivityDetails;
